var _excluded = ["title", "stroke", "dir"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgStarHalfFade = function SvgStarHalfFade(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Half Faded Star' : _ref$title,
    stroke = _ref.stroke,
    dir = _ref.dir,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 46 44"
  }, dir === 'rtl' ? {
    transform: 'scale(-1, 1)'
  } : {}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.825 36L8.72 43.416l2.694-15.708L0 16.584l15.772-2.292L22.825 0z",
    strokeWidth: 3,
    stroke: stroke
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    strokeWidth: 3,
    stroke: stroke,
    points: "22.8253564 36 22.8253564 2.34479103e-13 29.8787794 14.2917961 45.6507128 16.5835921 34.2380346 27.7082039 36.9322024 43.4164079"
  })));
};
SvgStarHalfFade = pure(SvgStarHalfFade);
SvgStarHalfFade.displayName = 'SvgStarHalfFade';
export default SvgStarHalfFade;